import BaseObject from '../../../base/base_object';
import DOM from '../../../utils/dom';
import {TimeSpan} from "@sparkware/app-utils";
import {SYSTEM_EVENTS} from '../../../events/events';
import Event from '../../../utils/event';

export default class UserScrollDetector extends BaseObject {
    static CLASS = "UserScrollDetector";

    _getScrollY = () => window.scrollY;
    _now = () => Date.now();
    _scrollCheckingInterval = TimeSpan.fromMinutes(1);

    _lastScrollY = null;
    _lastScrollTime = null;
    _onScrollCallback = null;

    init(params) {
        super.init(params);

        params = params || {};

        this._now = params.now || this._now;
        this._scrollCheckingInterval = params.scrollCheckingInterval || this._scrollCheckingInterval;
        this._onScrollCallback = params.onScrollCallback;

        this._setLastScrollTime();
        this._setLastScrollY();
        this._startScrollCheckTimer();

        this._subscribe();
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.APP_RESUMED, this._startScrollCheckTimer, this);
        Event.on(SYSTEM_EVENTS.APP_PAUSED, this._stopScrollCheckTimer, this);
    }

    _unsubscribe() {
        Event.off(SYSTEM_EVENTS.APP_RESUMED, this._startScrollCheckTimer, this);
        Event.off(SYSTEM_EVENTS.APP_PAUSED, this._stopScrollCheckTimer, this);
    }


    getLastScrollTime() {
        return this._lastScrollTime;
    }

    _setLastScrollTime() {
        this._lastScrollTime = this._now();
        if(this._onScrollCallback) {
            this._onScrollCallback();
        }
    }

    setOnScrollCallback(onScrollCallback) {
        this._onScrollCallback = onScrollCallback;
    }

    _setLastScrollY() {
        this._lastScrollY = this._getScrollY();
    }

    _scrollCheckTimer = null;
    _startScrollCheckTimer() {
        this._stopScrollCheckTimer();
        this._scrollCheckTimer = DOM.setInterval(() => {
            if (this._getScrollY() !== this._lastScrollY) {
                this._setLastScrollTime();
                this._setLastScrollY();
            }
        }, this._scrollCheckingInterval.totalMilliseconds);
    }

    _stopScrollCheckTimer() {
        DOM.clearInterval(this._scrollCheckTimer);
    }

    dispose() {
        this._stopScrollCheckTimer();
        this._unsubscribe();
    }
}